import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';
import * as ValidateConstant from '../../../constants/ValidateConstant';

const homeDataStepView = (state = defaultState.turboCash.ui.homeDataStepView, action) => {
    switch (action.type) {
        case LoanApplicationActions.CLEAN_LOAN_APPLICATION_DATA_ACTION.name:
            return {
                ...state,
                hasPostalCodeError: false,
            };
        case LoanApplicationActions.ERROR_GOT_LOCATIONS_ACTION.name:
            return {
                ...state,
                hasPostalCodeError: true,
            };
        case WizardActions.CHANGE_HOME_ADDRESS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    addressFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOME_EXT_NUMBER_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    extNumberFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOME_INT_NUMBER_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    intNumberFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    postalCodeFieldError: action.error
                }
            };
        case WizardMXActions.NOT_FOUND_LOCATION_ERROR_MX_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    postalCodeFieldError: ValidateConstant.ERROR_POSTAL_CODE,
                    stateFieldError: ValidateConstant.ERROR_REQUIRED,
                    cityFieldError: ValidateConstant.ERROR_REQUIRED,
                    municipalityFieldError: ValidateConstant.ERROR_REQUIRED,
                    selectedColonyFieldError: ValidateConstant.ERROR_REQUIRED,
                }
            };
        case WizardActions.CHANGE_HOME_STATES_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    stateFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOME_CITY_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    cityFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOME_MUNICIPALITY_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    municipalityFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOME_COLONIES_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    selectedColonyFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOME_COLONY_MX_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    selectedColonyFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOME_PHONE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    phoneFieldError: action.error
                }
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.name:
            return defaultState.turboCash.ui.homeDataStepView;
        default:
            return state;
    }
};

export default homeDataStepView;